import { ButtonGroup, EmptyState, Flex, For, Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { Field } from '@app/components/ui/field'
import { NativeSelectField, NativeSelectRoot } from '@app/components/ui/native-select'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import AiDashboardAddNew from '@app/pages/aiDashboard/components/aiDashboardAddNew'
import AIDashboardReportList from '@app/pages/aiDashboard/components/aiDashboardReportList'
import type { DashboardItem } from '@app/pages/aiDashboard/types'
import { RecurringReportConfigurationServiceEnum } from '@graphql/types'

const Index = () => {
  const navigate = useNavigate()
  const { recurringReportId, strategyId } = useParams()
  const dashboardItems = useGetObjectsByProperties('recurringReportConfiguration', {
    strategyId,
    service: RecurringReportConfigurationServiceEnum.EmitReport
  })

  useEffect(() => {
    if (!recurringReportId && dashboardItems.length > 0) {
      navigate(`${dashboardItems[0].id}/current`)
    }
  })

  const handleReportChange = (e) => {
    navigate(`/strategy/${strategyId}/dashboard/${e.target.value}/current`)
  }

  return (
    <Flex h="full" direction={{ base: 'column', md: 'row' }}>
      <Flex
        grow={0}
        shrink={0}
        basis={72}
        bg="bg.panel"
        flexDirection="column"
        overflow="hidden"
        borderRight={1}
        borderColor="border"
        borderStyle="solid"
        h="full"
        hideBelow="md"
      >
        <Flex grow={1} direction="column" overflowY="auto" p={6}>
          <AIDashboardReportList reports={dashboardItems as DashboardItem[]} />
        </Flex>
        <Flex basis={8} justify="flex-end" p={6}>
          <AiDashboardAddNew strategyId={strategyId} />
        </Flex>
      </Flex>
      <Flex
        grow={0}
        shrink={0}
        hideFrom="md"
        bg="bg.panel"
        flexDirection="column"
        overflow="hidden"
        borderBottomWidth={1}
        borderBottomStyle="solid"
        borderColor="border"
      >
        <Stack gap={6} p={6}>
          <Field label="Report">
            <NativeSelectRoot>
              <NativeSelectField onChange={handleReportChange} value={recurringReportId}>
                <For each={dashboardItems as DashboardItem[]} fallback={<option>No reports</option>}>
                  {(report) => (
                    <option key={report.id} value={report.id}>
                      {report.name}
                    </option>
                  )}
                </For>
              </NativeSelectField>
            </NativeSelectRoot>
          </Field>
          <AiDashboardAddNew strategyId={strategyId} />
        </Stack>
      </Flex>
      <Flex grow={1} bg="bg.panel" overflow="hidden">
        {!dashboardItems.length && (
          <EmptyState.Root>
            <EmptyState.Content>
              <EmptyState.Title>No reports yet</EmptyState.Title>
              <EmptyState.Description>
                Create a new report to receive recurring updates on your companies strategy.
              </EmptyState.Description>
              <ButtonGroup>
                <AiDashboardAddNew strategyId={strategyId} />
              </ButtonGroup>
            </EmptyState.Content>
          </EmptyState.Root>
        )}
        <Outlet />
      </Flex>
    </Flex>
  )
}

export default Index
